import { BooleanInput, Edit, SimpleForm, TextInput } from "react-admin";

export function WalletEdit() {
  return (
    <Edit mutationMode="pessimistic">
      <SimpleForm>
        <TextInput source="address" disabled fullWidth sx={{ fontFamily: "monospace" }} />
        <TextInput source="label" fullWidth />
        <BooleanInput source="is_active" />
      </SimpleForm>
    </Edit>
  );
}
